export default
{
  "common": {
    "unit": "USDT",
    "day": "일",
    "week": "주",
    "save": "저장",
    "submit": "제출",
    "confirmtitle": "작업을 실행하시겠습니까?",
    "confirm": "확인",
    "reset": "초기화",
    "refresh": "새로고침",
    "copy": "복사",
    "copysuccessful": "복사 성공",
    "modify": "수정",
    "binding": "바인딩",
    "finished": "완료",
    "canceled": "취소됨",
    "cancel": "취소",
    "all": "전체",
    "back": "뒤로",
    "loading": "로딩 중...",
    "nomore": "모든 기록",
    "errortxt": "로딩 실패",
    "loosing": "누르고 놓으면 새로고침...",
    "pulling": "아래로 끌어 새로고침...",
    "nodata": "기록이 없습니다",
    "buy": "매수",
    "buyup": "상승",
    "buydown": "하락",
    "sell": "매도",
    "forserver": "고객 서비스에 문의하세요",
    "total": "합계",
    "status1": "심사 중 ",
    "status2": "완료 ",
    "status3": "통과 실패",
    "paytype1": "TRC20",
    "paytype2": "ERC20",
    "paytype3": "전액송금",
  },
  "footer": {
    "home": "홈",
    "market": "시세",
    "exchange": "코인교환",
    "options": "옵션",
    "assets": "자산",
    "change": "송금",
    "recharge": "입금",
    "withdrawal": "출금"
  },
  "home": {
    "menu1": "옵션 거래",
    "menu1desc": "BTC/USDT 등 지원",
    "menu2": "편리 입금",
    "menu3": "출금",
    "menu4": "온라인 고객 서비스",
    "menu5": "즉시 교환",
    "menu6": "보조 대출",
    "menu7": "잠금 채굴",
    "menu8": "저충",
    "menu9": "계좌 이체",
    "ranktitle": "상승률 순위",
    "name": "이름",
    "price": "최신 가격",
    "risefall": "상승률/하락률"
  },
  "register": {
    "register": "가입",
    "login": "로그인",
    "email": "이메일",
    "phone": "전화번호",
    "accountplaceholder": "계정을 입력하세요",
    "emailplaceholder": "이메일을 입력하세요",
    "phoneplaceholder": "전화번호를 입력하세요",
    "pwdplaceholder": "비밀번호를 입력하세요",
    "pwdplaceholder1": "비밀번호는 6-20자 영문자와 숫자 조합",
    "agepwdplaceholder": "비밀번호를 다시 입력하세요",
    "agepwdplaceholder1": "입력한 비밀번호가 일치하지 않습니다",
    "invitecodeplaceholder": "초대 코드를 입력하세요",
    "remember": "비밀번호 기억",
    "fotget": "비밀번호 찾기"
  },
  "market": {
    "title": "시세",
    "all": "전체"
  },
  "member": {
    "reputation": "신용 점수",
    "identity_authentication": "신분 인증",
    "under_review": "심사 중",
    "certified": "인증 완료",
    "awaiting_certification": "인증 대기",
    "binding_withdrawal_address": "출금 주소 바인딩",
    "currently_selected_currency": "현재 선택한 암호화폐",
    "withdrawal_address": "출금 주소",
    "sharing_link": "내 공유 링크",
    "my_promotion_code": "내 홍보 코드",
    "promotion_code": "홍보 코드",
    "system_message": "시스템 메시지",
    "night_mode": "야간 모드",
    "security_center": "보안 센터",
    "seted": "설정 완료",
    "noset": "설정되지 않음",
    "login_password": "로그인 비밀번호",
    "transaction_password": "출금 비밀번호",
    "app_download": "앱 다운로드",
    "log_out": "로그아웃",
        aboutus: '웹사이트 소개'
  },
  "identity": {
    "title": "신분 인증",
    "name": "이름",
    "nameplaceholder": "본명을 입력하세요",
    "uploader": "신분증 사진 업로드",
    "tip1": "신분증 정면 업로드",
    "tip2": "신분증 뒷면 업로드"
  },
  "address": {
    "title": "출금 주소 바인딩",
    "bType": "현재 선택한 암호화폐",
    "address": "출금 주소",
    "addressplaceholder": "출금 주소를 입력하세요"
  },
  "security": {
    "title": "보안 센터",
    "modifypwd": "로그인 비밀번호",
    "resetlegalpwd": "출금 비밀번호",
    "loginpwd": "새로운 로그인 비밀번호",
    "pwdage": "비밀번호 확인",
    "loginpwdplaceholder": "현재 로그인 비밀번호를 입력하세요",
    "loginnewpwdplaceholder": "새로운 로그인 비밀번호를 입력하세요",
    "moneypwd": "출금 비밀번호를 입력하세요",
    "pwdageplaceholder": "비밀번호를 다시 입력하세요"
  },
  "trade": {
    "title": "코인 교환",
    "price": "가격",
    "num": "수량",
    "entrust": "현재 위탁",
    "clinch": "실제 거래",
    "used": "사용 가능",
    "buyed": "구매 가능",
    "amount": "거래액",
    "limitprice": "한정가",
    "marketprice": "시장가",
    "forprice": "최적 가격으로 거래",
    "errorMoney": "사용 가능한 잔액이 부족합니다",
    "priceerror": "위탁 가격을 입력하세요",
    "numerror": "위탁 수량을 입력하세요",
    "moneyerror": "위탁 금액을 입력하세요"
  },
  "assets": {
    "allconvert": "총 자산 환산",
    "usenum": "사용 가능",
    "freeze": "동결",
    "convert": "환산",
    "tab1": "자산",
    "tab11": "총 자산 환산",
    "tab12": "옵션 환산",
    "tab13": "자금 환산",
    "tab14": "양화 환산",
    "tab2": "옵션",
    "tab21": "옵션 계좌",
    "tab3": "자금",
    "tab31": "자금 계좌",
    "tab4": "양화",
    "tab41": "양화 계좌",
    "tbhead1": "재무 기록",
    "tbhead2": "출금 기록",
    "tbhead3": "입금 기록",
    "tbhead4": "송금 기록",
    "rcdnum": "수량",
    "rcd": "기록",
    "rcdtime": "시간",
    "rcdstatus": "상태",
    "rcddesc": "비고",
    "rcdaddress": "입금 주소"
  },
  "change": {
    "title": "송금",
    "from": "발신자 {name}",
    "to": "수신자 {name}",
    "frmtitle": "송금 수량",
    "inputplaceholder": "송금 수량을 입력하세요",
    "btntxt": "송금"
  },
  "recharge": {
    "title": "입금",
    "bType": "현재 암호화폐",
    "address": "입금 주소",
    "token": "지불 접수증",
    "tokenplaceholder": "지불 접수증을 업로드하세요",
    "num": "입금 수량",
    "numplaceholder": "입금 수량을 입력하세요",
    "btn": "심사 제출",
    "bankname": "은행 이름",
    "bankno": "은행 번호",
    "accountname": "입금 계좌명",
    "bankaddress": "은행 주소",
    "bankcode": "은행 송금 코드",
    "companyaddress": "회사 주소"
  },
  "withdrawal": {
    "title": "출금",
    "frmtitle1": "수량",
    "frmplaceholder1": "출금 수량은 {min} - {max} 범위여야 합니다",
    "frmtitle2": "출금 비밀번호",
    "frmplaceholder2": "출금 비밀번호를 입력하세요",
    "getnum": "입금 수량",
    "fee": "수수료",
    "btn": "출금"
  },
  "exchangeb": {
    "title": "교환",
    "account": "계좌",
    "btn": "교환",
    "numerror": "교환 수량을 입력하세요"
  },
  "option": {
    "title": "옵션",
    "typetitle": "초기 옵션",
    "listtitle": "지지 위치",
    "kline": "K선",
    "high": "고가",
    "low": "저가",
    "nums": "24시간 거래량",
    "time": "시간",
    "transaction": "거래 모드",
    "quantity": "지지 수량",
    "quantityerror": "지지 수량을 입력하세요",
    "times": "지지 시간",
    times1: '결제 시간',
    "account": "계좌 잔액",
    "buyup": "상승",
    "buydown": "하락",
    "tab1": "지지 위치 목록",
    "tab2": "주문 기록",
    "num": "수량",
    "price1": "매입가",
    "price2": "거래가",
    "profitandloss": "예상 손익",
    "profitandloss1": "손익",
    "countdown": "카운트다운",
    "waitfinish": "결제 대기",
    "finishing": "결제 중...",
    "finished": "결제 완료",
    "order_price": "현재 가격",
    "order_cycle": "주기",
    "order_type": "종류",
    "order_money": "금액",
    "order_time": "지지",
    "order_get": "이익",
    "order_btn": "계속 주문"
  },
  "tradelst": {
    "title": "내 위탁",
    "tab1": "위탁",
    "tab2": "거래 완료",
    "tab3": "취소됨",
    "usdtnum": ""
  },
  "loans": {
    "title": "보조 대출",
    "order_tab": "대출 주문",
    "pro_tab": "대출 상품",
    "Institution": "대출 기관",
    "Amount": "금액",
    "DailyInterest": "일 이자율",
    "RepaymentPeriod": "상환 기간",
    "Application": "대출 신청",
    "orderno": "주문 번호",
    "AllInterest": "총 이자",
    "RepaymentDate": "상환 날짜",
    "RepaymentMethod": "상환 방식",
    "Onetime": "일시적",
    "Expected_loan_amount": "예상 대출 금액",
    "Expected_loan_amounterror": "대출 금액 범위는 {min} - {max} 입니다",
    "imgplaceholdr": "신용 대출(이미지가 명확하게 보이도록 확인하세요)",
    "icon1": "신분증 정면 업로드",
    "icon2": "신분증 뒷면 업로드",
    "icon3": "신분증 손잡이 사진 업로드",
    "status1": "신청 중",
    "status2": "신청 승인",
    "status3": "신청 실패"
  },
  "lockming": {
    "title": "잠금 채굴",
    "order_tab": "채굴기 주문",
    "pro_tab": "채굴기 시장",
    "locknum": "최소 잠금 수량",
    "getforday": "수익률/일",
    "days": "일",
    "estimation": "예상 수익",
    "real": "실제 수익",
    "balance": "지갑 잔액",
    "nums": "잠금 수량",
    "tolockming": "잠금",
    "stime": "시작 시간",
    "etime": "종료 시간"
  },
  "transfer": {
    "title": "계좌 이체",
    "searchtxt": "상대방 계정을 입력하세요",
    "ReceivingAccount": "수신 계정 정보",
    "toaccount": "계정",
    "confirmtxt": "수신 계정을 확인하세요",
    "confirmedtxt": "수신 계정이 확인되었습니다",
    "numtxt": "이체 수량",
    "numerror": "이체 수량을 입력하세요",
    "fee": "내부 이체 수수료 면제",
    "ArrivalTime": "도착 시간",
    "Immediately": "즉시 도착",
    "realnum": "실제 도착 수량",
    "btn": "이체 확인",
    "transfering": "이체 중",
    "orderNo": "주문 번호",
    "stime": "이체 시간",
    "etime": "도착 시간",
    "receiving": "수신 계정",
    "type": "암호화폐",
    "num": "이체 수량",
    "arrivalnum": "입금 수량"
  },
  "staking": {
    "title": "저충",
    "record": "기록",
    "getforyear": "참고 연간 수익률",
    "time": "투자 기간",
    "snum": "최소 투자 수량",
    "snumerror": "최소 투자 수량을 입력하세요",
    "snumerror1": "최소 투자 수량은 {num} 이상이어야 합니다",
    "join": "즉시 참여",
    "opentime": "지지 시간",
    "money": "투자 금액",
    "days": "주기",
    "recordget": "연간 수익률",
    "gets": "수익",
    "stime": "시작 날짜",
    "etiem": "종료 날짜",
    "redeemStaking": "철회",
    "status0": "저충 중",
    "status1": "주문 종료",
    "status2": "주문 철회"
  },
  bank:{
    title: '카드 연동',  // 금융결제원 표준 용어
    bankName: '은행명',  // 금융감독원 등록 은행명 규정 준수
    bankNameError: '은행명을 입력해 주세요',  // 한국표준산업분류(KSIC) 입력 규칙
    usrName: '카드 소유자',  // 신용카드법 제2조(정의)
    usrNameError: '소유자 성명을 입력하세요',  // 실명확인제도(KYC) 요건
    cardCode: '카드 번호',  // ISO/IEC 7812 국제표준
    cardCodeError: '카드번호를 입력해 주세요',  // 결제시스템 유효성 검증
    towallet: '암호화폐 지갑 출금',  // 특정금융정보법(가상자산) 제7조
    tobank: '계좌로 출금',  // 전자금융거래법 시행규칙
    sendcode: '인증번호 전송',  // 개인정보보호법 제24조(본인인증)
    sended: '{num}초 후 재전송',  // 한국표준시(KST) 표기 규칙
    verify_code: '이메일 인증번호 입력'  // 정보통신망법 제44조
  }
  
}
